import { render, staticRenderFns } from "./settlement_list.vue?vue&type=template&id=fa0a8acc&"
import script from "./settlement_list.vue?vue&type=script&lang=js&"
export * from "./settlement_list.vue?vue&type=script&lang=js&"
import style0 from "./settlement_list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports